import React, { useEffect, useRef, useState } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { classNames } from 'primereact/utils';
import axios from 'axios';
import { Toast } from 'primereact/toast';
import { useFormik } from 'formik';
import { Dropdown } from 'primereact/dropdown';
import { Api } from '../../services/api';
import { MultiSelect } from 'primereact/multiselect';

const ManageUser = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);

    const [users, setUsers] = useState([]);
    const [type, setType] = useState('Add');
    const [userId, setUserID] = useState('');

    const [roles, setRoles] = useState([]);
    const [division, setDivision] = useState([]);
 
    const toast = useRef(null);

    const [isLoading, setIsLoading] = useState(true);

    const formik = useFormik({
        initialValues: {
            first_name: '',
            last_name: '',
            password: '',
            labourBurden: '',
            billableRate: '',
            division: '',
            email: '',
            role_id: '',

        },
        validate: (data) => {
            let errors = {};

            if (!data.first_name) {
                errors.first_name = 'First Name is required.';
            }
            if (!data.last_name) {
                errors.last_name = 'Last Name is required.';
            } if (!data.password) {
                errors.password = 'Password is required.';
            }

            if (!data.email) {
                errors.email = 'Email is required.';
            }

            if (!data.role_id) {
                errors.role_id = 'Role is required.';
            }
    
            return errors;
        },

        onSubmit: (data) => {
            var url = Api.API_BASE_URL + 'create-user-register';
            if (type == "Edit") {
                url = Api.API_BASE_URL + 'update-user-register/' + userId;
            }

            fetch(url, {
                method: "POST",
                headers: {

                },
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((Josn) => {
                    if (Josn.error != '') {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
                       closeModal();
                       getUser();
                    }
                
                })
                .catch((error) => {
                    console.error("Error:", error);
                });


        }
    });

    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);



    const openModal = () => {
        setType('Add');
        formik.resetForm();

        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const openEditModal = (event) => {
        formik.setFieldValue('first_name', event.first_name);
        formik.setFieldValue('last_name', event.last_name);
        formik.setFieldValue('password', 'event.password');
        formik.setFieldValue('labourBurden', event.labourBurden);
        formik.setFieldValue('billableRate', event.billableRate);
        formik.setFieldValue('email', event.email);
        formik.setFieldValue('role_id', event.role_id);
        formik.setFieldValue('default_project', event.default_project);
        formik.setFieldValue('division', event.division);

        setType('Edit');
        setUserID(event.user_id);

        setIsModalOpen(true);
    };


    useEffect(() => {


        getUser();
        getRoles();

    }, []);

    const getRoles = async () => {
        axios.get(Api.API_BASE_URL + 'get-all-active-role')
            .then((response) => {
                setRoles(response.data.result);

            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
            });
    }

    const getUser = async () => {
        axios.get(Api.API_BASE_URL + 'get-user-register')
            .then((response) => {
                setUsers(response.data.result);
                setDivision(response.data.division);
               
                setIsLoading(false);
            
            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
                setIsLoading(false);
            });
    }

    // ---------------------------------------------------------------------------------
    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
            
                <Button icon="pi pi-pencil" rounded outlined className="mr-2" onClick={() => openEditModal(rowData)} />
                       <Button icon="pi pi-trash" rounded outlined severity="danger" />
            </React.Fragment>
        );
    };


    return (
        <>

            {/* // -------------------------------------------------------------------------------------- */}

            <div style={{ textAlign: "end", padding: "10px 10px 0" }}>
                <button type="button" className="custom-button" onClick={openModal} >
                    + ADD
                </button>
            </div>
            {/* // -------------------------------------------------------------------------------------- */}
            <div className="pagee-container">
                <Toast ref={toast} />
                <div className="card">
                    {isLoading ? (
                        <div className="loading-spinner">
                            Loading...
                            <div className="spinner"></div>
                        </div>
                    ) : (
                        <DataTable
                            value={users}
                            paginator
                            rows={10}
                            dataKey="id"
                            tableStyle={{ minWidth: '50rem' }}
                            selectionMode="single"
                            emptyMessage="No records found"

                        >
                            <Column field="first_name" header="First Name" style={{ textAlign: 'center' }} ></Column>
                            <Column field="last_name" header="Last Name" style={{ textAlign: 'center' }}></Column>
                            <Column field="email" header="Email" style={{ textAlign: 'center' }}></Column>
                            <Column field="name" header="Role" style={{ textAlign: 'center' }}></Column>
                            <Column field="divisionName" header="division" style={{ textAlign: 'center' }}></Column>
                          
                            <Column body={actionBodyTemplate} header="Action" exportable={false} style={{ minWidth: '12rem', textAlign: 'center' }}></Column>
                        </DataTable>
                    )}
                </div>
            </div>


          
            {/* // -------------------------------------------------------------------------------------- */}
            <Dialog header="" visible={isModalOpen} maximizable style={{ width: '50vw' }} dismissableMask="true" onHide={() => setIsModalOpen(false)}>
                <div className='card'>
                    <form onSubmit={formik.handleSubmit} className="" >
                        <div className=" formgrid grid">

                            <div className="col-6">
                                <label>First Name</label>
                                <InputText
                                    id="first_name"
                                    name="first_name"
                                    value={formik.values.first_name}
                                    onChange={(e) => {
                                        console.log(e.target.value);
                                        formik.setFieldValue('first_name', e.target.value);
                                    }}
                                    className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('first_name') })} style={{ width: '100%' }}
                                />
                            </div>
                            
                            <div className="col-6">
                                <label>Last Name</label>
                                <InputText
                                    id="last_name"
                                    name="last_name"
                                    value={formik.values.last_name}
                                    onChange={(e) => {
                                        formik.setFieldValue('last_name', e.target.value);
                                    }}
                                    className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('last_name') })} style={{ width: '100%' }}
                                />
                            </div>

                            <div className="col-6 pt-2">
                                <label>Email</label>
                                <InputText
                                    id="email"
                                    name="email"
                                    value={formik.values.email}
                                    onChange={(e) => {
                                        formik.setFieldValue('email', e.target.value);
                                    }}
                                    className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('email') })} style={{ width: '100%' }}
                                />
                            </div>

                            {type === "Add" ? (<div className="col-6 pt-2">
                                <label>Password</label>
                                <InputText

                                    id="password"
                                    name="password"

                                    value={formik.values.password}
                                    onChange={(e) => {


                                        formik.setFieldValue('password', e.target.value);
                                    }}
                                    className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('password') })} style={{ width: '100%' }}
                                />
                            </div>) : (<div></div>)
                            }

                            <div className="col-6 pt-2">
                                <label>Labour Burden</label>
                                <InputText
                                    id="labourBurden"
                                    name="labourBurden"
                                    value={formik.values.labourBurden}
                                    onChange={(e) => {
                                        formik.setFieldValue('labourBurden', e.target.value);
                                    }}
                                    className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('labourBurden') })} style={{ width: '100%' }}
                                />
                            </div>

                            <div className="col-6 pt-2">
                                <label>Billable Rate</label>
                                <InputText
                                    id="billableRate"
                                    name="billableRate"
                                    value={formik.values.billableRate}
                                    onChange={(e) => {
                                        formik.setFieldValue('billableRate', e.target.value);
                                    }}
                                    className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('billableRate') })} style={{ width: '100%' }}
                                />
                            </div>

                            <div className="col-6 pt-2">
                                <label>Role</label>
                                <Dropdown
                                    optionValue='id'
                                    id="role_id"
                                    name="role_id"
                                    placeholder="Select a Role"
                                    options={roles}
                                    optionLabel="name"
                                    value={formik.values.role_id}

                                    onChange={(e) => {
                                        console.log(e.value);
                                        formik.setFieldValue('role_id', e.value);
                                    }}
                                    className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('role_id') })} style={{ width: '100%' }}
                                />
                            </div>

                            <div className="col-6 pt-2">
                                <label>Devision</label>
                                <MultiSelect
                                    optionValue='id'
                                    id="division"
                                    name="division"
                                    placeholder="Select a Devision"
                                    options={division}
                                    optionLabel="title"
                                    value={formik.values.division}

                                    onChange={(e) => {
                                        console.log(e.value);
                                        formik.setFieldValue('division', e.value);
                                    }}
                                    className={classNames('p-2')} style={{ width: '100%' }}
                                />
                            </div>

                           

                        </div>
                        <div className="card flex flex-wrap justify-content-center gap-3">
                            <Button label="Submit" type="submit" className='p-2' />
                        </div>

                    </form>

                </div>
            </Dialog>

        </>
    )
}

export default ManageUser